<template>
  <th 
    v-bind="$attrs"
    class="uppercase bg-white py-6 px-8 border-b-0 border-collapse text-left text-gray-500"
  >
    <slot />
  </th>
</template>